import React, { useState, useRef } from "react";
import Header from "../../components/Header";
import PageContainer from "../../components/PageContainer";
import Sidebar from "../../components/Sidebar";
// import DeleteButton from "../../components/actions/DeleteButton";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
//import { deleteService } from "../../services/deleteService";
import toast, { Toaster } from "react-hot-toast";
import ReactTooltip from "react-tooltip";
import FirmFlowTable from "../../components/mytasks/FirmFlowTable";
import { getJobs } from "../../services/jobs/getJobs";
import DeleteModal from "../../utils/DeleteModal";
import { deleteJob } from "../../services/jobs/deleteJob";
import FullSizeModal from "../../components/shared/FullSizeModal";
import CreateJob from "./CreateJob";
import { cloneJob } from "../../services/jobs/cloneJob";
import GenericModal from "../../utils/GenericModal";
import CloneJobForm from "./CloneJobForm";
import { term } from "../../terms";
import { usePermissions } from "../../context/PermissionsContext";

function PipelinesList() {
    const { can, permissionsLoading } = usePermissions();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    // const [selectedItems, setSelectedItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [jobs, setJobs] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [jobIdToDelete, setJobIdToDelete] = useState("");
    const [isAddJobModalOpen, setIsAddJobModalOpen] = useState(false);
    const cancelButtonRef = useRef(null);
    const [jobToCloneId, setJobToCloneId] = useState(null);
    const [isCloneJobModalOpen, setIsCloneJobModalOpen] = useState(false);
    const noPermissionMessage = "You don't have permission to do this.";
    const canReadPipelines =
        can("pipelines.read") || can("pipelines.write") || can("pipelines.delete");
    const canWritePipelines = can("pipelines.write");
    const canDeletePipelines = can("pipelines.delete");

    //Set initial list
    useEffect(() => {
        if (permissionsLoading) return;
        if (!canReadPipelines) {
            setJobs([]);
            setLoading(false);
            return;
        }

        getNewJobs();
    }, [canReadPipelines, permissionsLoading]);

    const getNewJobs = async () => {
        setLoading(true);
        const response = await getJobs();
        if (response.success) {
            setJobs(response?.data?.jobs || []);
        } else {
            if (!String(response?.message || "").includes("403")) {
                toast.error(response?.message || "Failed to load pipelines.");
            }
            setJobs([]);
        }
        setLoading(false);
    };

    const onClickRemoveJob = (jobId) => {
        if (!canDeletePipelines) return;
        setJobIdToDelete(jobId);
        setIsDeleteModalOpen(true);
    };

    const onRemoveJob = async () => {
        const response = await deleteJob(jobIdToDelete);
        if (response?.success || response?.data?.success) {
            toast.success(response?.data?.message || "Deleted");
            getNewJobs();
        } else {
            toast.error(response?.data?.message || response?.message);
        }
        setIsDeleteModalOpen(false);
    };

    const onClickAddJob = () => {
        if (!canWritePipelines) return;
        setIsAddJobModalOpen(true);
    };

    const onCloneJob = async (newName) => {
        const response = await cloneJob(jobToCloneId, newName);
        console.log(response);
        if (response.success) {
            toast.success(response.data.message);
            navigate(`/templates/job/${response.data.clonedJobId}`);
            //getNewJobs();
        } else {
            toast.error(response.data.message);
        }
        setIsCloneJobModalOpen(false);
    };
    /* const onHandleClickDeleteDeparment = (jobId) => {
    setIsDeleteModalOpen(true);
    setJobIdToDelete(jobId)
  } */
    /*
  const onRemoveDepartment = async () => {
    const response = await deleteDepartment(jobIdToDelete);
    if (response.success) {
      toast.success(response.data.message);
      setIsDeleteModalOpen(false);
      getNewJobs();
    } else {
      toast.error(response.data.message);
    }
  }; */

    const onClickCloneJob = (jobId) => {
        if (!canWritePipelines) return;
        setJobToCloneId(jobId);
        setIsCloneJobModalOpen(true);
    };

    return (
        <section>
            <Toaster />
            <ReactTooltip
                type="light"
                effect="solid"
                place="top"
                border={true}
                borderColor={"rgb(220,220,220)"}
                className="rounded-md bg-gray-50"
                multiline={false}
            />
            <DeleteModal
                isModalOpen={isDeleteModalOpen}
                title={"Are you sure to delete this item?"}
                setIsModalOpen={setIsDeleteModalOpen}
                onRemove={onRemoveJob}
            />
            <FullSizeModal
                cancelButtonRef={cancelButtonRef}
                isModalOpen={isAddJobModalOpen}
                setIsModalOpen={setIsAddJobModalOpen}
            >
                <CreateJob
                    setIsModalOpen={setIsAddJobModalOpen}
                    getNewJobs={getNewJobs}
                />
            </FullSizeModal>
            <GenericModal
                cancelButtonRef={cancelButtonRef}
                isModalOpen={isCloneJobModalOpen}
                setIsModalOpen={setIsCloneJobModalOpen}
                title={`What is the name of the new ${term("pipeline_singular")}?`}
            >
                <CloneJobForm
                    label=""
                    onAction={onCloneJob}
                    setIsModalOpen={setIsCloneJobModalOpen}
                    cancelButtonRef={cancelButtonRef}
                    onActionText={"Clone"}
                />
            </GenericModal>
            {/*  <DeleteModal
        isModalOpen={isCloneJobModalOpen}
        title="Are you sure you want to clone this job?"
        setIsModalOpen={setIsCloneJobModalOpen}
        onRemove={onCloneJob}
        buttonText="Clone"
      /> */}
            {/* <DeleteModal isModalOpen={isDeleteModalOpen} setIsModalOpen={setIsDeleteModalOpen} onRemove={onRemoveDepartment}/> */}
            <div className="flex h-screen overflow-hidden">
                {/* Sidebar */}
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                {/* Content area */}
                <div className="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto">
                    {/*  Site header */}
                    <Header
                        sidebarOpen={sidebarOpen}
                        setSidebarOpen={setSidebarOpen}
                    />

                    <PageContainer
                        isLoading={loading}
                        loadingText={`Loading ${term("pipeline_plural").toLowerCase()}...`}
                    >
                        <main>
                            <div className="w-full px-4 py-8 mx-auto sm:px-6 lg:px-8 max-w-9xl">
                                {/* Page header */}
                                <div className="mb-8 sm:flex sm:justify-between sm:items-center">
                                    {/* Left: Title */}
                                    <div className="mb-4 sm:mb-0">
                                        <h1 className="text-2xl font-bold md:text-3xl text-slate-800">
                                            {term("pipeline_plural")}
                                        </h1>
                                    </div>

                                    {/* Right: Actions */}
                                    <div className="grid items-end justify-start grid-flow-col gap-2 sm:auto-cols-max sm:justify-end">
                                        {/* Add service button */}
                                        <span
                                            data-tip={
                                                canWritePipelines
                                                    ? `Add ${term("pipeline_singular")}`
                                                    : noPermissionMessage
                                            }
                                            className="inline-flex"
                                        >
                                            <button
                                                onClick={() => onClickAddJob()}
                                                disabled={!canWritePipelines}
                                                className={`h-10 text-white bg-teal-500 btn ${
                                                    canWritePipelines
                                                        ? "hover:bg-teal-600"
                                                        : "opacity-50 cursor-not-allowed"
                                                }`}
                                            >
                                                <svg
                                                    className="w-4 h-4 opacity-50 fill-current shrink-0"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                </svg>
                                                <span className="ml-2 xs:block">
                                                    Add {term("pipeline_singular")}
                                                </span>
                                            </button>
                                        </span>

                                        {/* Clone button */}
                                        {/* <button onClick={() => clone()} className="h-10 text-white bg-teal-500 btn hover:bg-teal-600">
                      <svg className="w-4 h-4 opacity-50 fill-current shrink-0" viewBox="0 0 16 16">
                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                      </svg>
                      <span className="ml-2 xs:block">Clone Service Template</span>
                    </button> */}
                                    </div>
                                </div>

                                {canReadPipelines ? (
                                    <FirmFlowTable
                                        columns={[
                                            {
                                                Header: "Name",
                                                accessor: "name",
                                                Cell: (props) => (
                                                    <a
                                                        href={`/templates/job/${props.row.original.id}`}
                                                        className="text-gray hover:text-blue-500 rounded-ful"
                                                    >
                                                        {props.value}
                                                    </a>
                                                ),
                                            },
                                            {
                                                Header: "Actions",
                                                accessor: "id",
                                                Cell: (props) => (
                                                    <>
                                                        <span
                                                            data-tip={
                                                                canWritePipelines
                                                                    ? "Edit"
                                                                    : noPermissionMessage
                                                            }
                                                            className="inline-flex"
                                                        >
                                                            <button
                                                                onClick={() =>
                                                                    navigate(
                                                                        `/templates/job/${props.value}`,
                                                                    )
                                                                }
                                                                disabled={!canWritePipelines}
                                                                className={`w-20 h-10 mx-2 text-white bg-teal-500 btn ${
                                                                    canWritePipelines
                                                                        ? "hover:bg-teal-600"
                                                                        : "opacity-50 cursor-not-allowed"
                                                                }`}
                                                            >
                                                                Edit
                                                            </button>
                                                        </span>
                                                        <span
                                                            data-tip={
                                                                canWritePipelines
                                                                    ? "Clone"
                                                                    : noPermissionMessage
                                                            }
                                                            className="inline-flex"
                                                        >
                                                            <button
                                                                onClick={() =>
                                                                    onClickCloneJob(
                                                                        props.value,
                                                                    )
                                                                }
                                                                disabled={!canWritePipelines}
                                                                className={`w-20 h-10 mx-2 text-white bg-yellow-500 btn ${
                                                                    canWritePipelines
                                                                        ? "hover:bg-yellow-600"
                                                                        : "opacity-50 cursor-not-allowed"
                                                                }`}
                                                            >
                                                                Clone
                                                            </button>
                                                        </span>
                                                        <span
                                                            data-tip={
                                                                canDeletePipelines
                                                                    ? "Delete"
                                                                    : noPermissionMessage
                                                            }
                                                            className="inline-flex"
                                                        >
                                                            <button
                                                                onClick={() =>
                                                                    onClickRemoveJob(
                                                                        props.value,
                                                                    )
                                                                }
                                                                disabled={!canDeletePipelines}
                                                                className={`w-20 h-10 mx-2 text-white bg-red-500 btn ${
                                                                    canDeletePipelines
                                                                        ? "hover:bg-red-600"
                                                                        : "opacity-50 cursor-not-allowed"
                                                                }`}
                                                            >
                                                                Delete
                                                            </button>
                                                        </span>
                                                    </>
                                                ),
                                            },
                                        ]}
                                        data={jobs}
                                    />
                                ) : (
                                    <div className="p-4 text-sm border rounded-sm border-slate-200 text-slate-600">
                                        You don't have permission to view pipelines.
                                    </div>
                                )}
                            </div>
                        </main>
                    </PageContainer>
                </div>
            </div>
        </section>
    );
}
export default PipelinesList;
